import React, { useEffect, useState } from "react";
import "./Cookies.scss";

import CustomButton from "../CustomButton/CustomButton";
import { Capacitor } from "@capacitor/core";
import { storage } from "../../helpers/storage";

const Cookies = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleInitialState = async () => {
      const acceptedCookies = await storage.get("acceptedCookies");
      if (acceptedCookies) {
        setOpen(false);
      } else {
        setOpen(true);
      }
    }

    handleInitialState();
  }, []);

  const handleAcceptCookies = () => {
    storage.set("acceptedCookies", true);
    setOpen(false);
  };
  if (Capacitor.isNativePlatform()) {
    return <></>;
  } else {
    return (
      <>
        <div className={`cookies-accept-form ${open ? "active" : ""}`}>
          <h1>COOKIE PREFERENCES</h1>
          <p>
            We use cookies to improve your experience. Do you accept our use of
            cookies?
          </p>

          <div className="buttons">
            <CustomButton
              name={"Reject"}
              color={"danger"}
              type={"button"}
              handleSubmit={() => {
                setOpen(false);
              }}
              disabled={false}
            />
            <CustomButton
              name={"Accept"}
              color={"primary"}
              type={"button"}
              handleSubmit={handleAcceptCookies}
              disabled={false}
            />
          </div>
        </div>
        {open && <div className="cookies-blur-back"></div>}
      </>
    );
  }
};

export default Cookies;
